module.exports = __webpack_public_path__ + "assets/004480df173a58a25860f838256da265.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/freespin/freegames.mp3
 ** module id = 237
 ** module chunks = 0
 **/